import { call, put, takeEvery } from "redux-saga/effects";

import {
  AGENDA_LIST,
  AGENDA_FULLLIST,
  AGENDA_FILTER,
  AGENDA_CREATE,
  AGENDA_UPDATE,
  AGENDA_DELETE
} from "./actionTypes";

import {
 agendaListSuccess,
 agendaFuLLListSuccess,
 agendaCreateSuccess,
 agendaUpdateSuccess,
 agendaDeleteSuccess,
 agendaRequestFailed,
} from "./actions";

import {
  getAgendaList,
  getAgendaFullList,
  getAgendaFilter,
  postAgendaCreate,
  patchAgendaUpdate,
  deleteAgenda,
} from "../../helpers/backend";

function*agendaListSaga() {
  console.log("Trayendo lista de agenda...");
  try {
    const response = yield call(getAgendaList);
    if (response.status === 200) {
      yield put(agendaListSuccess(response.data));
    } else {
      yield put(agendaRequestFailed(response.data));
    }
  } catch (error) {
    yield put(agendaRequestFailed(error.response.data));
  }
}
function*agendaFuLllistSaga() {
  console.log("Trayendo lista de FullList...");
  try {
    const response = yield call(getAgendaFullList);
    if (response.status === 200) {
      yield put(agendaFuLLListSuccess(response.data));
     
    } else {
      yield put(agendaRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(agendaRequestFailed(error.response.data));
  }
}

function*agendaCreateSaga({ payload:agenda }) {
  console.log("Creando nuevo agenda...");
  try {
    const response = yield call(postAgendaCreate,agenda);
    if (response.status === 201) {
      yield put(agendaCreateSuccess(response.data));
    } else {
      yield put(agendaRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(agendaRequestFailed(error.response.data));
  }
}

function*agendaFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getAgendaFilter, { changeUrl });
    if (response.status === 200) {
      yield put(agendaListSuccess(response.data));
    } else {
      yield put(agendaRequestFailed(response.data));
    }
  } catch (error) {
    yield put(agendaRequestFailed(error.response.data));
  }
}

function*agendaUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la  AGENDA...");
  try {
    const response = yield call(patchAgendaUpdate, { id }, data);
    if (response.status === 200) {
      yield put(agendaUpdateSuccess(response.data));
    } else {
      yield put(agendaRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(agendaRequestFailed(error.response.data));
  }
}

function*agendaDeleteSaga({ payload: { id } }) {
  console.log("Borrando datos de la agenda...");
  try {
    const response = yield call(deleteAgenda, id );
    if (response.status === 204) {
      yield put(agendaDeleteSuccess(response.data));
    } else {
      yield put(agendaRequestFailed(response.data));
    }
  } catch (error) {
    yield put(agendaRequestFailed(error.response.data));
  }
}

export default function*agendaSaga() {
  yield takeEvery(AGENDA_LIST,agendaListSaga);
  yield takeEvery(AGENDA_FILTER,agendaFilterSaga);
  yield takeEvery(AGENDA_CREATE,agendaCreateSaga);
  yield takeEvery(AGENDA_UPDATE,agendaUpdateSaga);
  yield takeEvery(AGENDA_DELETE,agendaDeleteSaga);
  yield takeEvery(AGENDA_FULLLIST,agendaFuLllistSaga);
}
